import onSetInfo from 'local/test/events/onSetInfo';
import onConfiguration from 'local/test/events/onConfiguration';
import updateResult from 'local/test/updateResult';
import onMeasurementInfo from 'local/test/events/onMeasurementInfo';
import onReport from 'local/test/events/onReport';

const events = {
	setInfo: onSetInfo,
	configuration: onConfiguration,
	taskProgress: updateResult,
	measurementInfo: onMeasurementInfo,
	report: onReport,
};

export function route(m, e, defaultHandler) {
	if (events[e.event]) {
		events[e.event](m, e.args);
	} else if (e.event === 'taskComplete' && e.args.task !== 'global') {
		updateResult(m, e.args);
	} else {
		defaultHandler(m, e);
	}
}
